import i18n from '../../i18n'

export default class InputWithLengthLimit {
  constructor(input) {
    this.input = input
    this.limit = this.input.dataset.lengthLimit
    this.appendLengthRequirementInfoToLabel()
    this.countContainer = this.insertCountContainer()
    this.attachListener()
    if (this.input.localName !== 'textarea') {
      // cannot use maxLength on textareas because browsers aren't consistent about the length of a new line
      this.input.setAttribute('maxlength', this.limit)
    }

    this.updateCountContainerText()
  }

  appendLengthRequirementInfoToLabel() {
    const label = document.querySelector(`label[for="${this.input.id}"]`)
    const span = document.createElement('span')

    span.innerText = i18n.$ngettext('Maximum %{max} character', 'Maximum %{max} characters', this.limit, {
      max: this.limit
    })
    span.classList.add('sr_only')
    label.appendChild(span)
  }

  insertCountContainer() {
    this.input.insertAdjacentHTML('afterend', '<div class="input_with_length_limit" />')
    return this.input.nextElementSibling
  }

  updateCountContainerText() {
    const currentValue = this.input.value
    let currentLength = currentValue.length

    if (currentLength > this.limit) {
      this.input.value = currentValue.substring(0, this.limit)
      // When using `data-update-from-input` we listen to input events.
      // Sadly setting the value on the input does not retrigger this event.
      this.input.dispatchEvent(new Event('input'))
      currentLength = this.limit
    }

    const label = i18n.$ngettext('%{total} out of %{max} character', '%{total} out of %{max} characters', this.limit, {
      max: this.limit,
      total: currentLength
    })

    this.countContainer.innerHTML =
      `<span aria-hidden="true" title="${label}">${currentLength} / ${this.limit}</span>` +
      `<span class="sr_only">${label}</span>`
  }

  attachListener() {
    up.on(
      this.input,
      'change keyup paste',
      function () {
        this.updateCountContainerText()
      }.bind(this)
    )
  }
}
